<template>
    <div :class="$root.edit ? 'editing' : ''">
        <v-card v-if="$root.edit && !$store.state.editMenu" width="100%" @click="setEditComponent" flat tile>
            <v-card-title class="headline zoezi-edit-color">
                <div class="d-flex align-center justify-center fill-width">
                    {{$translate('Page')}} {{$translate(name)}}
                    <v-spacer/>
                    <v-btn icon @click="aiPrompt = ''; aiDialog = true">
                        <v-icon color="primarytext">mdi-auto-fix</v-icon>
                    </v-btn>

                    <v-dialog v-model="aiDialog" max-width="600px" v-if="aiDialog">
                        <v-card>
                            <v-card-title class="zoezi-edit-color headline align-start flex-column pa-2">
                                <div class="font-weight-bold fill-width">
                                    Ändra sidan med hjälp av AI
                                    <v-btn icon @click="aiDialog = false" class="float-right zoezi-edit-color"><v-icon>mdi-close</v-icon></v-btn>
                                </div>
                                <div class="text-caption mt-2 px-2" style="opacity: 0.7;">
                                    Denna AI-funktion är i labbstadiet och har begränsade förfrågningar. 
                                    Vi kan inte garantera resultatets kvalitet, och funktionen kan ändras 
                                    eller bli ett tillval i framtiden.
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-text-field autofocus label="Beskriv vad du vill ändra" color="zoezi-edit-color" v-model="aiPrompt" @keyup.enter="changeUsingAi" :loading="aiLoading" :disabled="aiLoading">
                                    <template v-slot:append>
                                        <v-btn icon @click="changeUsingAi" :loading="aiLoading">
                                            <v-icon>mdi-send-circle-outline</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </div>
            </v-card-title>
        </v-card>

        <component-wrapper
            ref="component"
            :config="config"
            :key="renderKey"
            :ripple="false"
        />
    </div>
</template>
<script>
import components from '../component.js'
export default {
    name: 'zoezi-page',

    zoezi: {
        title: 'Page',
        icon: 'mdi-book-open-variant',
        internal: true
    },
    props: {
        config: {
            title: 'Component',
            type: Object,
            fulltype: 'component',
            default: () => components.makeEmptyConfig({component: 'zoezi-rowlayout'})
        },
        name: {
            title: 'Page name',
            type: String
        },
        path: {
            title: 'Link',
            type: String,
            fulltype: 'path'
        },
        redirect: {
            title: 'Redirection',
            type: String,
            fulltype: 'page',
            typeinfo: {
                clearable: true,
                routeFilter: (r, props) => !r.props.redirect && r.props.path != props.path
            }
        },
        description: {
            title: 'Description',
            type: String,
            fulltype: 'textarea'
        },
        showInGoogle: {
            title: 'Show on Google',
            type: Number,
            fulltype: 'number-slider',
            typeinfo: {
                min: 0,
                max: 100,
                step: 5
            }
        }
    },
    data: () => ({
        renderKey: 0,
        showDrawer: true,
        aiPrompt: '',
        aiDialog: false,
        aiLoading: false
    }),
    methods: {
        setEditComponent() {
            this.$store.commit('setEditComponent', this);
        },
        getDocForComponents() {
            let doc = {components: []}
            const components =  window.$vue.$root.components.getAllComponents()
            for (let i = 0; i < components.length; i++) {
                const component = components[i];
                doc.components.push({
                    name: component.name,
                    title: component?.zoezi?.title,
                    props: component?.props
                })
            }
            return doc;
        },
        save() {
            this.$refs.component.save();
        },
        changeUsingAi() {
            this.aiLoading = true;
            this.$api.post('/api/homepage/page/ai/change', {doc: this.getDocForComponents(), page: this.config, prompt: this.aiPrompt}).then(response => {
                this.aiLoading = false;
                response.json().then(data => {
                    this.$store.commit('showErrorDialog', {title: 'Sida ändrad', text: data.info, color: 'zoezi-edit-color'})

                    this.config.component = data.page.component;
                    this.config.props = data.page.props;
                    this.config.style = data.page.style;
                    this.$root.saveHomePage();
                    this.aiDialog = false;
                })
            })
        }
    }
}
</script>
